import styled from "styled-components"
import { theme } from "../../../../../theme"

export const DiscountContainer = styled.div`
  background: ${(p) => p.theme.colors.white};
  border: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  border-radius: 0.6rem;
  padding: 2rem;
  display: flex;
  flex-direction: column;
  gap: 1.6rem;
`

export const BaseOrderValueRow = styled.div`
  display: flex;
  justify-content: space-between;
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLight};
  padding-bottom: 1rem;
`

export const OrderValueRow = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 0.8rem 0;
`

export const DiscountRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  padding: 0.8rem 0 2rem;
  border-bottom: 0.1rem solid ${(p) => p.theme.colors.greyLighter};

  &:last-of-type {
    border-bottom: none;
  }
`


export const BundleRow = styled(DiscountRow)`
flex-direction: column;

  span {
    width: 100%;
    display: flex;
    justify-content: space-between;
  }

`



export const TotalDiscountRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end;
  padding: 1.2rem 0;
  margin-top: 0.8rem;
`

export const BaseOrderLabel = styled.div`
  font-size: 1.4rem;
  font-weight: 500;
  margin-right: 0.4rem;
`

export const BaseOrderValue = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
`

export const DiscountLabel = styled.div`
  font-size: 1.4rem;
  font-weight: 700;
  line-height: 1.4;

  span {
    font-size: 1.2rem;
    font-weight: 400;
    display: flex;
    flex-direction: column;

    ${theme.mQ.MEDIA_MIN_MEDIUM} {
     flex-direction: row;
    }
  }
`

export const BundleDiscountLabel = styled(DiscountLabel)`
  display: flex;
  align-items: center;

  svg {
    height: 1.6rem;
    margin-left: 1rem;
  }
  &:hover {
    cursor: pointer;
  }
`

export const Value = styled.div`
  ${theme.mQ.MEDIA_MIN_MEDIUM} {
    margin-left: 0.5rem;
  }
`

export const DiscountValue = styled.div`
  font-size: 1.4rem;
  font-weight: 600;
  text-align: right;
`

export const TotalDiscountLabel = styled.div`
  font-size: 1.2rem;
  margin-bottom: 1rem;
`

export const TotalDiscountValue = styled.div`
  font-size: 4rem;
  font-weight: 700;
`


